import React, { useCallback, useState } from 'react';
import { useTranslations } from '@altermaind/core/i18n';
import { Box, Button, Svg, Typography } from '@altermaind/web/ui';
import { Routes } from '@/_shared/constants/routes';
import { useResponsiveStyle } from '@/_shared/hooks/useResponsiveStyle';

export const ConfigurationCompletedThankYouPage = () => {
  const t = useTranslations('configuration.hr.typ.configurationCompletedThankYouPage');
  const { genericResponsiveValue } = useResponsiveStyle();
  const [loading, setLoading] = useState(false);

  const goToSlash = useCallback(() => {
    setLoading(true);
    window.location.href = Routes.Homepage;
  }, []);

  return (
    <Box mt='xl' mb='xl'>
      <Box
        display='flex'
        flexDirection='row'
        justifyContent='center'
        alignItems='center'
        minHeight='60vh'
      >
        <Box
          width='100%'
          display='flex'
          flexDirection='column'
          justifyContent='center'
          alignItems='center'
          textAlign='center'
          flex='1'
        >
          <Box
            display='flex'
            flexDirection='row'
            alignItems='center'
            justifyContent='center'
            mb='xs'
            bg='primary'
            p='xxs'
            borderRadius='100%'
          >
            <Svg name='check' size='m' />
          </Box>
          <Typography
            variant='h1'
            color='primary/text'
            fontSize={genericResponsiveValue({
              breakPoints: { desktop: 50 as never },
              defaultValue: 'xxxl',
            })}
            lineHeight={genericResponsiveValue({
              breakPoints: { desktop: '60px' as never },
              defaultValue: 'xxxl',
            })}
            fontWeight='bold'
            mb={genericResponsiveValue({
              breakPoints: { desktop: 'm' },
              defaultValue: 'xs',
            })}
          >
            {t('title')}
          </Typography>
          <Typography variant='h4' fontWeight={200} mt='s' color='primary/text'>
            {t('subtitle')}
          </Typography>
          <Button
            loading={loading}
            spinnerColor='white'
            variant='primary'
            mt='m'
            onClick={goToSlash}
          >
            {t('cta.next')}
          </Button>
        </Box>
      </Box>
    </Box>
  );
};
